(() => {
  let listenersAttached = false;
  let discountRequestInProgress = false;

  function initDiscountScript() {
    const appliedDiscountsContainer =
      document.getElementById('applied-discounts');

    const applyBtn =
      document.getElementById('apply-discount-btn');

    const discountInput =
      document.getElementById('discount-input');

    if (!appliedDiscountsContainer || !applyBtn || !discountInput) {
      return;
    }

    const strings = window.cartDiscountStrings || {};

    const MSG_NO_CODE =
      strings.errorNoCode ||
      'Please enter a discount code.';

    const MSG_ALREADY_APPLIED =
      strings.errorAlreadyApplied ||
      'That discount code is already applied.';

    const MSG_INVALID =
      strings.errorInvalid ||
      'Discount code is invalid or not applicable.';

    /* =========================================================
       HELPERS
    ========================================================= */

    function clearMessages() {
      const errDiv =
        document.getElementById('discount-error-message');

      if (errDiv) {
        errDiv.style.display = 'none';
        errDiv.textContent = '';
      }
    }

    function showError(message) {
      const errDiv =
        document.getElementById('discount-error-message');

      if (errDiv) {
        errDiv.style.display = 'block';
        errDiv.textContent = message;
      }
    }

    function normalizeCode(code) {
      return (code || '').trim().toUpperCase();
    }

    /* =========================================================
       GET CURRENTLY DISPLAYED DISCOUNTS
    ========================================================= */

    function getCurrentDiscounts() {
      const pills = document.querySelectorAll(
        '#applied-discounts .discount-pill[data-code]'
      );

      return Array.from(pills)
        .map((pill) =>
          normalizeCode(
            pill.getAttribute('data-code')
          )
        )
        .filter(Boolean);
    }

    /* =========================================================
       GET ACTIVE DISCOUNTS FROM CART
    ========================================================= */

    function getCartDiscountCodes(cartData) {
      const activeCodes = [];

      /*
       * Cart level discounts
       */
      (cartData.cart_level_discount_applications || []).forEach(
        (discount) => {
          if (discount && discount.title) {
            activeCodes.push(
              normalizeCode(discount.title)
            );
          }
        }
      );

      /*
       * Line level discounts
       */
      (cartData.items || []).forEach((item) => {
        (
          item.line_level_discount_allocations || []
        ).forEach((allocation) => {
          if (
            allocation &&
            allocation.discount_application &&
            allocation.discount_application.title
          ) {
            activeCodes.push(
              normalizeCode(
                allocation.discount_application.title
              )
            );
          }
        });
      });

      return [...new Set(activeCodes)];
    }

    /* =========================================================
       SYNC DISCOUNT UI WITH SHOPIFY CART
    ========================================================= */

    function syncDiscountUI(cartData) {
      if (!cartData) {
        return;
      }

      const activeDiscounts =
        getCartDiscountCodes(cartData);

      const container =
        document.getElementById('applied-discounts');

      const input =
        document.getElementById('discount-input');

      if (!container) {
        return;
      }

      /*
       * Remove pills which are no longer active
       * in Shopify cart.
       */
      const pills =
        container.querySelectorAll(
          '.discount-pill[data-code]'
        );

      pills.forEach((pill) => {
        const code =
          normalizeCode(
            pill.getAttribute('data-code')
          );

        if (
          code &&
          !activeDiscounts.includes(code)
        ) {
          pill.remove();
        }
      });

      /*
       * Clear input if its code is no longer active.
       */
      if (input) {
        const inputCode =
          normalizeCode(input.value);

        if (
          inputCode &&
          !activeDiscounts.includes(inputCode)
        ) {
          input.value = '';
        }
      }
    }

    /* =========================================================
       ADD DISCOUNT PILL IMMEDIATELY
    ========================================================= */

    function addDiscountPill(code) {
      const container =
        document.getElementById('applied-discounts');

      if (!container) {
        return;
      }

      const normalizedCode =
        normalizeCode(code);

      if (!normalizedCode) {
        return;
      }

      /*
       * Don't create duplicate pill.
       */
      const existingPill =
        Array.from(
          container.querySelectorAll(
            '.discount-pill[data-code]'
          )
        ).find(
          (pill) =>
            normalizeCode(
              pill.getAttribute('data-code')
            ) === normalizedCode
        );

      if (existingPill) {
        return;
      }

      /*
       * Create discount pill.
       */
      const pill =
        document.createElement('div');

      pill.className = 'discount-pill';
      pill.setAttribute(
        'data-code',
        normalizedCode
      );

      /*
       * Discount code text.
       */
      const codeText =
        document.createElement('span');

      codeText.className =
        'discount-code';

      codeText.textContent =
        normalizedCode;

      /*
       * Remove button.
       */
      const removeButton =
        document.createElement('button');

      removeButton.type = 'button';

      removeButton.className =
        'remove-discount';

      removeButton.setAttribute(
        'aria-label',
        `Remove ${normalizedCode}`
      );

      removeButton.innerHTML = '&times;';

      /*
       * Build pill.
       */
      pill.appendChild(codeText);
      pill.appendChild(removeButton);

      /*
       * Add immediately to DOM.
       */
      container.appendChild(pill);
    }

    /* =========================================================
       FETCH CART
    ========================================================= */

    async function getCart() {
      const response = await fetch(
        window.Shopify.routes.root + 'cart.js',
        {
          method: 'GET',
          credentials: 'include',
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!response.ok) {
        throw new Error(
          'Unable to fetch cart.'
        );
      }

      return await response.json();
    }

    /* =========================================================
       REFRESH CART UI
    ========================================================= */

    async function refreshCartUI() {
      if(window.location.pathname === '/cart'){
        window.location.reload();
      }
      /*
       * Try Dawn/Shopify cart drawer methods first.
       */
      const cartDrawer =
        document.querySelector('cart-drawer');

      if (
        cartDrawer &&
        typeof cartDrawer.onCartUpdate === 'function'
      ) {
        try {
          await cartDrawer.onCartUpdate();
          return;
        } catch (error) {
          console.warn(
            'cart-drawer.onCartUpdate failed:',
            error
          );
        }
      }

      /*
       * Try cart drawer items.
       */
      const cartDrawerItems =
        document.querySelector(
          'cart-drawer-items'
        );

      if (
        cartDrawerItems &&
        typeof cartDrawerItems.onCartUpdate === 'function'
      ) {
        try {
          await cartDrawerItems.onCartUpdate();
          return;
        } catch (error) {
          console.warn(
            'cart-drawer-items.onCartUpdate failed:',
            error
          );
        }
      }

      /*
       * Try regular cart items.
       */
      const cartItems =
        document.querySelector(
          'cart-items'
        );

      if (
        cartItems &&
        typeof cartItems.onCartUpdate === 'function'
      ) {
        try {
          await cartItems.onCartUpdate();
          return;
        } catch (error) {
          console.warn(
            'cart-items.onCartUpdate failed:',
            error
          );
        }
      }

      // const oldMainCartFooter = document.querySelector('#main-cart-footer');
      // if(oldMainCartFooter){
      //   const newMainCartFooter = mainCartFooter.querySelector('.shopify-section').querySelector('#main-cart-footer');
      //   oldMainCartFooter.innerHTML = newMainCartFooter.innerHTML;
      // }

      /*
       * If theme has PUB_SUB_EVENTS,
       * publish cart update event.
       */
      if (
        typeof publish === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        try {
          publish(
            PUB_SUB_EVENTS.cartUpdate,
            {
              source: 'discount-script'
            }
          );

          return;
        } catch (error) {
          console.warn(
            'Cart update event failed:',
            error
          );
        }
      }

      /*
       * No cart refresh method found.
       */
      console.warn(
        'No cart refresh method found.'
      );
    }

    /* =========================================================
       UPDATE SHOPIFY DISCOUNT
    ========================================================= */

    async function applyDiscounts(
      discountCodes = []
    ) {
      if (discountRequestInProgress) {
        return {
          success: false,
          invalidCodes: [],
          error:
            'Request already in progress.'
        };
      }

      discountRequestInProgress = true;

      try {
        const normalizedCodes = [
          ...new Set(
            discountCodes
              .map(normalizeCode)
              .filter(Boolean)
          )
        ];

        /*
         * Multiple discount codes:
         *
         * CODE1,CODE2
         *
         * No discount:
         *
         * ""
         */
        const discountString =
          normalizedCodes.join(',');

        const response = await fetch(
          window.Shopify.routes.root +
            'cart/update.js',
          {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type':
                'application/json',
              Accept:
                'application/json'
            },
            body: JSON.stringify({
              discount: discountString,
              sections: ['main-cart-footer']
            })
          }
        );

        if (!response.ok) {
          throw new Error(
            `Discount update failed: ${response.status}`
          );
        }

        /*
         * Shopify returns updated cart.
         */
        const cartData =
          await response.json();

        /*
         * Fetch fresh cart once more.
         */
        const freshCart =
          await getCart();

        const activeDiscounts =
          getCartDiscountCodes(
            freshCart
          );

        /*
         * Find codes which Shopify
         * did NOT apply.
         */
        const invalidCodes =
          normalizedCodes.filter(
            (code) =>
              !activeDiscounts.includes(
                normalizeCode(code)
              )
          );

        /*
         * If there were no codes,
         * removal was successful.
         */
        const success =
          normalizedCodes.length === 0
            ? true
            : invalidCodes.length <
              normalizedCodes.length;

        /*
         * Refresh cart UI.
         */
        await refreshCartUI();

        return {
          success,
          invalidCodes,
          cartData: freshCart
        };

      } catch (error) {
        console.error(
          'Discount update error:',
          error
        );

        return {
          success: false,
          invalidCodes: discountCodes,
          error
        };

      } finally {
        discountRequestInProgress =
          false;
      }
    }

    /* =========================================================
       APPLY DISCOUNT
    ========================================================= */

    async function handleApplyDiscount() {
      clearMessages();

      const input =
        document.getElementById(
          'discount-input'
        );

      if (!input) {
        return;
      }

      const newCode =
        normalizeCode(input.value);

      /*
       * Empty code.
       */
      if (!newCode) {
        showError(MSG_NO_CODE);
        return;
      }

      /*
       * Get latest Shopify cart first.
       *
       * This prevents stale DOM data.
       */
      let currentCart;

      try {
        currentCart =
          await getCart();
      } catch (error) {
        console.error(
          'Unable to get current cart:',
          error
        );

        showError(MSG_INVALID);
        return;
      }

      /*
       * Existing active Shopify discounts.
       */
      const existingCodes =
        getCartDiscountCodes(
          currentCart
        );

      /*
       * Already applied.
       */
      if (
        existingCodes.includes(
          newCode
        )
      ) {
        showError(
          MSG_ALREADY_APPLIED
        );
        return;
      }

      /*
       * Add new code to existing codes.
       */
      const combinedCodes = [
        ...existingCodes,
        newCode
      ];

      /*
       * Send to Shopify.
       */
      const result =
        await applyDiscounts(
          combinedCodes
        );

      /*
       * Shopify rejected the newly entered code.
       */
      const newCodeWasInvalid =
        result.invalidCodes.some(
          (code) =>
            normalizeCode(code) ===
            newCode
        );

      if (
        !result.success ||
        newCodeWasInvalid
      ) {
        showError(MSG_INVALID);

        /*
         * Restore previous valid discounts.
         */
        if (existingCodes.length) {
          await applyDiscounts(
            existingCodes
          );
        } else {
          await applyDiscounts([]);
        }

        return;
      }

      /*
       * =====================================================
       * SUCCESS
       * =====================================================
       */

      /*
       * Keep code visible in input.
       */
      input.value = newCode;

      clearMessages();

      /*
       * Sync with latest Shopify cart.
       */
      if (result.cartData) {
        syncDiscountUI(
          result.cartData
        );
      }

      /*
       * IMPORTANT:
       *
       * Add the pill immediately after successful
       * discount application.
       *
       * This makes the X/remove icon appear
       * without refreshing the page.
       */
      addDiscountPill(
        newCode
      );
    }

    /* =========================================================
       REMOVE DISCOUNT
    ========================================================= */

    async function handleRemoveDiscount(
      removeButton
    ) {
      clearMessages();

      if (!removeButton) {
        return;
      }

      const pill =
        removeButton.closest(
          '.discount-pill'
        );

      if (!pill) {
        return;
      }

      const codeToRemove =
        normalizeCode(
          pill.getAttribute(
            'data-code'
          )
        );

      if (!codeToRemove) {
        return;
      }

      /*
       * Get latest Shopify cart.
       */
      let currentCart;

      try {
        currentCart =
          await getCart();
      } catch (error) {
        console.error(
          'Unable to get current cart:',
          error
        );

        showError(MSG_INVALID);
        return;
      }

      /*
       * Get actual active codes from Shopify.
       */
      const existingCodes =
        getCartDiscountCodes(
          currentCart
        );

      /*
       * Remove clicked code.
       */
      const newDiscountList =
        existingCodes.filter(
          (code) =>
            normalizeCode(code) !==
            codeToRemove
        );

      /*
       * Update Shopify.
       *
       * If empty:
       * discount: ""
       *
       * This removes all discounts.
       */
      const result =
        await applyDiscounts(
          newDiscountList
        );

      /*
       * If Shopify failed.
       */
      if (
        !result.success &&
        newDiscountList.length > 0
      ) {
        showError(MSG_INVALID);
        return;
      }

      /*
       * IMPORTANT:
       *
       * Remove pill immediately from DOM.
       */
      pill.remove();

      /*
       * Clear input if removed code
       * is currently shown there.
       */
      const discountInput =
        document.getElementById(
          'discount-input'
        );

      if (
        discountInput &&
        normalizeCode(
          discountInput.value
        ) === codeToRemove
      ) {
        discountInput.value = '';
      }

      /*
       * Sync UI with Shopify.
       */
      if (result.cartData) {
        syncDiscountUI(
          result.cartData
        );
      }

      clearMessages();
    }

    /* =========================================================
       EVENT LISTENERS
    ========================================================= */

    if (!listenersAttached) {
      /*
       * CLICK EVENTS
       */
      document.addEventListener(
        'click',
        async (event) => {

          /*
           * APPLY BUTTON
           */
          const applyButton =
            event.target.closest(
              '#apply-discount-btn'
            );

          if (applyButton) {
            event.preventDefault();

            await handleApplyDiscount();

            return;
          }

          /*
           * REMOVE DISCOUNT
           */
          const removeButton =
            event.target.closest(
              '.remove-discount'
            );

          if (removeButton) {
            event.preventDefault();

            await handleRemoveDiscount(
              removeButton
            );
          }
        }
      );

      /*
       * ENTER KEY SUPPORT
       */
      document.addEventListener(
        'keydown',
        async (event) => {
          if (
            event.key === 'Enter' &&
            event.target &&
            event.target.id ===
              'discount-input'
          ) {
            event.preventDefault();

            await handleApplyDiscount();
          }
        }
      );

      listenersAttached = true;
    }
  }

  /* =========================================================
     INITIAL LOAD
  ========================================================= */

  async function initialDiscountSync() {
    /*
     * First initialize script.
     */
    initDiscountScript();

    /*
     * Then sync current Shopify discounts.
     */
    try {
      const cart =
        await fetch(
          window.Shopify.routes.root +
            'cart.js',
          {
            method: 'GET',
            credentials: 'include',
            headers: {
              Accept:
                'application/json'
            }
          }
        );

      if (!cart.ok) {
        return;
      }

      const cartData =
        await cart.json();

      /*
       * Get container.
       */
      const container =
        document.getElementById(
          'applied-discounts'
        );

      if (!container) {
        return;
      }

      /*
       * Get active discounts.
       */
      const activeDiscounts = [];

      (
        cartData.cart_level_discount_applications ||
        []
      ).forEach((discount) => {
        if (
          discount &&
          discount.title
        ) {
          activeDiscounts.push(
            (discount.title || '')
              .trim()
              .toUpperCase()
          );
        }
      });

      (
        cartData.items || []
      ).forEach((item) => {
        (
          item.line_level_discount_allocations ||
          []
        ).forEach((allocation) => {
          if (
            allocation &&
            allocation.discount_application &&
            allocation.discount_application.title
          ) {
            activeDiscounts.push(
              (
                allocation
                  .discount_application
                  .title || ''
              )
                .trim()
                .toUpperCase()
            );
          }
        });
      });

      const uniqueActiveDiscounts =
        [
          ...new Set(
            activeDiscounts
          )
        ];

      /*
       * Remove stale pills.
       */
      const pills =
        container.querySelectorAll(
          '.discount-pill[data-code]'
        );

      pills.forEach((pill) => {
        const code =
          (
            pill.getAttribute(
              'data-code'
            ) || ''
          )
            .trim()
            .toUpperCase();

        if (
          code &&
          !uniqueActiveDiscounts.includes(
            code
          )
        ) {
          pill.remove();
        }
      });

    } catch (error) {
      console.warn(
        'Initial discount sync failed:',
        error
      );
    }
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initialDiscountSync();
      }
    );
  } else {
    initialDiscountSync();
  }


  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !==
      'undefined' &&
    PUB_SUB_EVENTS.cartUpdate
  ) {
    subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      () => {
        setTimeout(
          async () => {
            initDiscountScript();

            try {
              const response =
                await fetch(
                  window.Shopify.routes.root +
                    'cart.js',
                  {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                      Accept:
                        'application/json'
                    }
                  }
                );

              if (!response.ok) {
                return;
              }

              const cartData =
                await response.json();
              const activeCodes = [];

              (
                cartData
                  .cart_level_discount_applications ||
                []
              ).forEach(
                (discount) => {
                  if (
                    discount &&
                    discount.title
                  ) {
                    activeCodes.push(
                      (
                        discount.title ||
                        ''
                      )
                        .trim()
                        .toUpperCase()
                    );
                  }
                }
              );

              (
                cartData.items || []
              ).forEach((item) => {
                (
                  item
                    .line_level_discount_allocations ||
                  []
                ).forEach(
                  (allocation) => {
                    if (
                      allocation &&
                      allocation.discount_application &&
                      allocation
                        .discount_application
                        .title
                    ) {
                      activeCodes.push(
                        (
                          allocation
                            .discount_application
                            .title ||
                          ''
                        )
                          .trim()
                          .toUpperCase()
                      );
                    }
                  }
                );
              });

              const uniqueCodes =
                [
                  ...new Set(
                    activeCodes
                  )
                ];
              const container =
                document.getElementById(
                  'applied-discounts'
                );

              if (!container) {
                return;
              }

              const pills =
                container.querySelectorAll(
                  '.discount-pill[data-code]'
                );

              pills.forEach(
                (pill) => {
                  const code =
                    (
                      pill.getAttribute(
                        'data-code'
                      ) || ''
                    )
                      .trim()
                      .toUpperCase();

                  if (
                    code &&
                    !uniqueCodes.includes(
                      code
                    )
                  ) {
                    pill.remove();
                  }
                }
              );
            } catch (error) {
              console.warn(
                'Cart discount sync failed:',
                error
              );
            }
          },
          50
        );
      }
    );
  }

  const observer =
    new MutationObserver(() => {
      const input =
        document.getElementById(
          'discount-input'
        );

      const button =
        document.getElementById(
          'apply-discount-btn'
        );

      if (
        input &&
        button
      ) {
        initDiscountScript();
      }
    });

  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();